import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../data/reducers';
import { ProductScrollWrapper } from '../../shared/components/product_components/product_scroll_wrapper';
import { ProductCard } from '../../shared/components/product_components/product_card';
import { NavigationShell } from '../../shared/navigation_shell/navigation_shell';
import * as storeActions from '../../data/reducers/store.reducer';
import { Product } from '../../data/models/product_list_response';
import { useNavigate, useParams } from 'react-router';
import { AppDispatch } from '../../data/storeConfig';
import * as assets from '../../assets/assets';
import { Link } from 'react-router-dom';
import HeaderBackground from '../../assets/placeholder/home_bg.jpg';
import { getImageUrl } from '../../utility/common';

export const HomePage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { storeInfo, storeProductList } = useSelector((rootState: RootState) => rootState.storeReducer);
  const [products, setProducts] = useState([]);
  const { storeSlug } = useParams<any>();

  useEffect(() => {
    if (storeSlug) {
      dispatch(storeActions.fetchStoreProductList({ storeSlug: storeSlug }));
    } else {
      // if store slug is empty or null,
      // redirect to yufin homepage
      navigate('https://www.yufin.ph');
    }
  }, [storeSlug]);

  useEffect(() => {
    const groupedProducts = storeProductList.reduce((acc: any, value: Product) => {
      // Group initialization
      if (!acc[value.productCategory.productCategoryName]) {
        acc[value.productCategory.productCategoryName] = [];
      }

      // Grouping
      acc[value.productCategory.productCategoryName].push(value);

      return acc;
    }, {});
    setProducts(groupedProducts);
  }, [storeProductList]);

  const [searchQuery, setSearchQuery] = useState('');

  const handleChangeQuery = (searchQuery: string) => {
    console.log(searchQuery);
  };
  return (
    <NavigationShell>
      <div className='-mt-14'>
        <div className="w-full h-64 object-fill align-bottom relative">
          <img className="absolute object-cover w-full h-64" src={storeInfo?.storeIcon ? getImageUrl([storeInfo?.storeIcon]) : HeaderBackground} />
          <div className="h-full bg-black opacity-50"></div>
          <div className="absolute bottom-12 w-11/12 max-h-48 left-4">
            <h4 className="text-white text-left overflow-ellipsis text-4xl font-medium">{storeInfo?.storeName}</h4>
            {storeInfo?.storeURL != 'store.yufin.ph/yufin-marketplace' && (
              <h6 className="text-white text-left overflow-ellipsis text-2xl">
                {storeInfo?.storeCategory?.storeCategoryName}
              </h6>
            )}
          </div>
        </div>

        {/* Seach Button */}
        <div className="mx-6 mt-6 mb-4 md:mx-6 md:mt-6 md:mb-4">
          <div className="flex md:flex">
            <div
              className="w-full md:w-full form-control font-sans font-medium border-none focus:outline-none text-slate-500 text-left"
              onClick={() => {
                navigate(`/${storeSlug}/search?${searchQuery}`);
              }}
            >
              Search...
            </div>
            {
              <div
                className="text-white focus:text-theLightOne"
                onClick={() => {
                  navigate(`/${storeSlug}/search?${searchQuery}`);
                }}
              >
                <img className="px-2 md:px-2" src={assets.icons.SearchIcon} />
              </div>
            }
          </div>

          <div className="mt-4 md:mt-4 border-t border-gray-300" />
        </div>

        {/* Product List Section - START */}
        {Object.keys(products).map((category, index) => {
          return (
            <div key={category} className="py-2">
              <div className="flex flex-row pt-2">
                <h6 className="text-left px-4 font-medium">{category.toUpperCase()}</h6>
                {/* <div className="flex w-1/2 px-4 place-content-end">
                  <Link
                    to={`category/${category}`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                      />
                    </svg>
                  </Link>
                </div> */}
              </div>

              <ProductScrollWrapper>
                {Object.values<Product[]>(products)[index].map((product: Product) => (
                  <ProductCard key={product.storeProductId} {...product} />
                ))}
              </ProductScrollWrapper>
            </div>
          );
        })}
      </div>
    </NavigationShell>
  );
};
